module.exports = __webpack_public_path__ + "img/serveMan.652118ca.png";